export default __webpack_public_path__ + "static/media/sortingIconDescending.8f5a2b32.svg";